module.exports = __webpack_public_path__ + "static/media/businessinterruption1.3a719462.jpg";